import { IMiddlewareEvent, applyAction } from 'mobx-state-tree';
import { Query } from 'mst-gql';
import { ClientError } from 'graphql-request';

const GRAPHQL_UNAUTHENTICATED_CODE = 'UNAUTHENTICATED';
const MSTGQL_ACTIONS = ['query', 'mutate'];

const isMstGqlAction = (call: IMiddlewareEvent) => (
  call.type === 'action' && MSTGQL_ACTIONS.indexOf(call.name) > -1
);

// Listens to mst-gql request actions and unauth user on error
export default (call: IMiddlewareEvent, next: (actionCall: IMiddlewareEvent, callback?: (value: any) => any) => void) => {
  if (isMstGqlAction(call)) {
    return next(call, (value: any) => {
      if (value instanceof Query) {
        value.currentPromise().catch((error: ClientError | undefined) => {
          if (error?.response?.errors?.find((err) => err.message === GRAPHQL_UNAUTHENTICATED_CODE)) {
            applyAction(call.tree, { name: 'logout', path: '/auth' });
          }
        });
      }

      return value;
    });
  }

  return next(call);
};
